import React from "react";
import { cn } from "@/utils/cn";

interface ScrollableContainerProps {
  children: React.ReactNode;
  className?: string;
  padding?: "none" | "sm" | "md" | "lg";
  height?: string;
  /** Ref to the inner scrolling element, e.g. for use as an IntersectionObserver root. */
  scrollRef?: React.Ref<HTMLDivElement>;
}

export const ScrollableContainer: React.FC<ScrollableContainerProps> = ({
  children,
  className,
  padding = "md",
  height = "calc(100vh - 180px)",
  scrollRef,
}) => {
  const getPaddingClass = () => {
    switch (padding) {
      case "none":
        return "p-0";
      case "sm":
        return "p-3";
      case "md":
        return "p-6";
      case "lg":
        return "p-8";
      default:
        return "p-6";
    }
  };

  // Card-less per DD-008: the media grid sits directly on the page canvas;
  // the tiles carry their own chrome.
  return (
    <div className={cn("flex flex-col overflow-hidden", className)} style={{ height }}>
      <div ref={scrollRef} className={cn("overflow-y-auto flex-1", getPaddingClass())}>
        {children}
      </div>
    </div>
  );
};
